import { IOrganizationAccountConfig } from "@wingspanhq/users/dist/lib/interfaces";
import { serviceCustomization } from "./serviceCustomization";

export const getCustomizationForUser = async (
  userId: string
): Promise<IOrganizationAccountConfig> => {
  const response = await serviceCustomization.get(`/customization/${userId}`);
  return response.data;
};
